<script>
import ElCollapse from 'element-ui/packages/collapse/src/collapse.vue'


export default {
  name: 'NoRetoggleCollapse',
  componentName: 'ElCollapse',
  extends: ElCollapse,
  methods: {
    handleItemClick(item) {
      // Accordion: re-clicking the open panel does nothing (default el-collapse would close it).
      if (this.accordion) {
        const current = this.activeNames[0]
        if (current === item.name) {
          return
        }
        this.setActiveNames(item.name)
        return
      }
      // Non-accordion: same as el-collapse — toggle this item in activeNames; multiple panels may be open.
      const activeNames = this.activeNames.slice(0)
      const index = activeNames.indexOf(item.name)
      if (index > -1) {
        activeNames.splice(index, 1)
      } else {
        activeNames.push(item.name)
      }
      this.setActiveNames(activeNames)
    },
  },
}
</script>
